import React from "react";
import { value as value_23, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Button } from "@mui/material";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";

export function Components_Button_Z1043B8E(components_Button_Z1043B8EInputProps) {
    const color = components_Button_Z1043B8EInputProps.color;
    const disabled = components_Button_Z1043B8EInputProps.disabled;
    const sx = components_Button_Z1043B8EInputProps.sx;
    const small = components_Button_Z1043B8EInputProps.small;
    const href = components_Button_Z1043B8EInputProps.href;
    const startIcon = components_Button_Z1043B8EInputProps.startIcon;
    const onClick = components_Button_Z1043B8EInputProps.onClick;
    const text = components_Button_Z1043B8EInputProps.text;
    const small_1 = defaultArg(small, false);
    const disabled_1 = defaultArg(disabled, false);
    return MuiHelpers_createElement(Button, toList(delay(() => append(singleton(["onClick", (arg) => {
        onClick(arg);
    }]), delay(() => append(singleton(["disabled", disabled_1]), delay(() => {
        let matchValue;
        return append((matchValue = color, (matchValue != null) ? ((matchValue === "green") ? singleton(["classes.root", "button-green"]) : ((matchValue === "gray") ? singleton(["classes.root", "button-gray"]) : singleton(["classes.root", "button"]))) : singleton(["classes.root", "button"])), delay(() => append(singleton(["sx", createObj(toList(delay(() => append(singleton(["lineHeight", 19.2 + "px"]), delay(() => append(singleton(["textTransform", "none"]), delay(() => append(!small_1 ? singleton(["padding", ((((((10 + "px ") + 20) + "px ") + 10) + "px ") + 20) + "px"]) : singleton(["padding", ((((((7 + "px ") + 10) + "px ") + 7) + "px ") + 10) + "px"]), delay(() => {
            const matchValue_1 = sx;
            if (matchValue_1 != null) {
                const styles = value_23(matchValue_1);
                return Object.entries(styles);
            }
            else {
                return empty();
            }
        })))))))))]), delay(() => append(small_1 ? singleton(["size", "small"]) : singleton(["size", "medium"]), delay(() => {
            let matchValue_2;
            return append((matchValue_2 = href, (matchValue_2 != null) ? singleton(["href", matchValue_2]) : (empty())), delay(() => {
                let matchValue_3;
                return append((matchValue_3 = startIcon, (matchValue_3 != null) ? singleton(["startIcon", matchValue_3([["sx", {
                    width: 1 + "rem",
                    height: 1 + "rem",
                }]])]) : (empty())), delay(() => singleton(["children", text])));
            }));
        }))))));
    })))))));
}

